import { Box, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import IntegrationsUpsellImg from "@app/analytics/assets/integrations_upsell.png";
import { ScrollableContent } from "@app/analytics/Integrations/styles";
import LINKS from "@app/common/links";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import Link from "@rui/Link";
import Stack from "@rui/Stack";

const Container = styled(Stack)(({ theme }) => ({
  backgroundColor: "#FFF",
  flex: 1,
  padding: theme.spacing(4),
}));

const UPSELL_CONFIG = {
  premium: {
    heading: "Automate your workflow with premium integrations",
    description: (
      <>
        Upgrade to{" "}
        <Link to={ROUTES.BILLING_COMPARE_PLANS}>Read Pro or Enterprise</Link> to
        get meeting recaps and insights automatically delivered to your favorite
        apps.
      </>
    ),
    primaryCta: {
      label: "Upgrade",
      to: ROUTES.BILLING_COMPARE_PLANS,
    },
    secondaryCta: {
      label: "Compare plans",
      href: LINKS.MARKETING.PLANS_PRICING,
    },
  },
  workspace: {
    heading: "Improve efficiency across your team",
    description: (
      <>
        Create a <Link to={ROUTES.NEW_WORKSPACE}>Read Workspace</Link> to get
        started with Workspace integrations, and automatically allow members to
        send meeting recaps to messenger platforms.
      </>
    ),
    primaryCta: {
      label: "Create a Workspace",
      to: ROUTES.NEW_WORKSPACE,
    },
    secondaryCta: {
      label: "Learn more about Read Workspaces",
      href: LINKS.MARKETING.WORKSPACES,
    },
  },
};

const IntegrationUpsell = ({ type }: { type: "premium" | "workspace" }) => {
  const config = UPSELL_CONFIG[type];
  return (
    <ScrollableContent>
      <Container variant="center" spacing={3}>
        <Box component="img" src={IntegrationsUpsellImg} width="200px" />
        <Stack maxWidth="500px" sx={{ textAlign: "center" }} spacing={1}>
          <Typography variant="h2" fontWeight={500} color="shades.neutral.800">
            {config.heading}
          </Typography>
          <Typography variant="bodySecondaryReg" color="shades.neutral.500">
            {config.description}
          </Typography>
        </Stack>
        <Stack spacing={2} variant="center">
          <Button
            component={Link}
            to={config.primaryCta.to}
            sx={{ minWidth: "150px" }}
          >
            {config.primaryCta.label}
          </Button>
          <Link
            variant="labelMed"
            color="shades.primary.500"
            href={config.secondaryCta.href}
          >
            {config.secondaryCta.label}
          </Link>
        </Stack>
      </Container>
    </ScrollableContent>
  );
};

export default IntegrationUpsell;
